import { getCryptoExport } from '../crypto.routes';

export const CRYPTO_EXPORT_ID = 'crypto-export';

export const downloadCryptoExport = ({
  positionDate,
  raptorPlatformId,
}: {
  positionDate: string;
  raptorPlatformId?: string;
}) => getCryptoExport(positionDate, raptorPlatformId);
